<p-dialog [header]="updateOf ? 'Update Address for ' + updateOf.partySiteName : 'Add Ship To Location to ' + poolerName" showEffect="fade" [modal]="true"
  [(visible)]="showDialog" (onHide)="closeShipToLocationDialog()" appendTo="body" [style]="{width: '700px'}">

  <form [formGroup]="form" (ngSubmit)="addShipToLocation()">
    <div class="p-grid">
        <div class="form-group p-col-6">
            <label for="locationName" class="required">Location Name</label>
            <input pInputText id="locationName" name="locationName" formControlName="locationName" required />
            <error-block [field]="form.controls.locationName" [messages]="{
              required: 'Location Name is required.'
            }"></error-block>
          </div>
      <div class="form-group p-col-6">
        <label for="chepGlobalLocationId" [class.required]="makeGlidRequired">
            Global Location ID
        </label>
        <input pInputText id="chepGlobalLocationId" name="chepGlobalLocationId" lib-alphanumeric formControlName="chepGlobalLocationId" />
        <error-block [field]="form.controls.chepGlobalLocationId" [messages]="{
                    required: 'GLID is required.'}">
        </error-block>
      </div>
    </div>

    <address-normalizer
      [initialAddress]="initialAddress"
      (selectedAddressChange)="onAddressSelected($event)">
    </address-normalizer>

    <customer-site-duplicate-list
      [config]="duplicateCheckConfig"
      (statusChange)="onDuplicateStatusChange($event)"
      (duplicateSelected)="onDuplicateSelected($event)">
    </customer-site-duplicate-list>

    <p-footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <div class="centered">
          <button type="button" pButton
                  label="Cancel"
                  class="p-button-secondary"
                  (click)="closeShipToLocationDialog()">
          </button>
          <button *ngIf="duplicateStatus?.sites?.length" type="button" pButton
              (click)="useSelectedDuplicate()"
              [disabled]="!canUseSelected"
              icon="pi pi-check"
              class="p-button-success"
              label="Use Selected">
          </button>
          <button *ngIf="!duplicateStatus?.sites?.length" type="button" pButton
              (click)="addShipToLocation()"
              [disabled]="!canSave"
              [icon]="working ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
              class="p-button-success"
              [label]="updateOf ? 'Update Address' : 'Create Ship To Location'">
          </button>
        </div>
      </div>
    </p-footer>
  </form>
</p-dialog>
